/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common';
import type { CashWallet, CashWalletInterface } from '../CashWallet';

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_cashToken',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'FeeSetting',
    type: 'error',
  },
  {
    inputs: [],
    name: 'Init',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidAmt',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidClaim',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrderBookIndex',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotOwner',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'addr',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256',
      },
    ],
    name: 'BalanceWithDraw',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'Balances',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_for',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256',
      },
    ],
    name: 'claimCash',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'currentCashBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'dividedByFee',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'factory',
    outputs: [
      {
        internalType: 'contract MerkleOrderbookFactory',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'feeBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_factory',
        type: 'address',
      },
    ],
    name: 'init',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'orderBookIndex',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
    ],
    name: 'payCash',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'orderBookIndex',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256',
      },
    ],
    name: 'payUnClaimed',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'setFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256',
      },
    ],
    name: 'validateUnclaimed',
    outputs: [],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
    ],
    name: 'withdrawFees',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

type CashWalletConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: CashWalletConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class CashWallet__factory extends ContractFactory {
  constructor(...args: CashWalletConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'CashWallet';
  }

  override deploy(
    _cashToken: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<CashWallet> {
    return super.deploy(_cashToken, overrides || {}) as Promise<CashWallet>;
  }
  override getDeployTransaction(
    _cashToken: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_cashToken, overrides || {});
  }
  override attach(address: string): CashWallet {
    return super.attach(address) as CashWallet;
  }
  override connect(signer: Signer): CashWallet__factory {
    return super.connect(signer) as CashWallet__factory;
  }
  static readonly contractName: 'CashWallet';

  public readonly contractName: 'CashWallet';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CashWalletInterface {
    return new utils.Interface(_abi) as CashWalletInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): CashWallet {
    return new Contract(address, _abi, signerOrProvider) as CashWallet;
  }
}
